export const servicesPage = {
  hero: {
    eyebrow: 'Our services',
    title: 'Everything your landscape needs.',
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/services-overview-design-development-20261103.png',
    alt: 'Designed planting beds, paver walks and newly planted street trees at a modern commercial campus.',
    imagePosition: '25% 60%',
    intro:
      'Plan a residential landscape, establish a development site or arrange care for commercial and HOA grounds. Explore the services below to find the right place to start.',
  },
  lead: {
    title: 'Design & development',
    intro:
      'Create a residential landscape made for outdoor enjoyment, or establish the planting and ground cover around a new site or community.',
  },
  care: {
    title: 'Property care',
    intro:
      'Care for commercial and HOA grounds, with snow, paved-area and construction-site services for the properties you manage.',
  },
  closing: {
    title: 'Let’s talk about your property.',
    text: 'Tell us what you have in mind for your landscape, development site or commercial property. We’ll help you find the right place to start.',
    action: { label: 'Start a conversation', href: '#service-inquiry' },
  },
};
